<div>
    <!-- fav icon-->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Favorite Icon</div></div>
        <div class="col-sm-3">
            <div class="form-group">
                <div class="c-form-group__label">
                    <label for="selIcon">Select Icon</label>
                </div>
                <ccl-simple-select formId="selIcon"
                    [listOfItems]="iconList['fav']"
                    (valueChange)="iconChange($event, 'favIcon', 'favIconSec', 'fav')"
                    [value]="buttonConfig.favIcon"
                    [bindValue]="'class'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="favColor">
                        Icon Color
                    </label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.favIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="favColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.favIconColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.favIconColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="favFontSize">Font Size</label></div>
                <ccl-simple-select formId="favFontSize"
                    [listOfItems]="sharedService.fontSizes"
                    (valueChange)="buttonConfig.favIconSize = $event.value"
                    [value]="buttonConfig.favIconSize"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div>
                <div class="c-form-group__label">
                    <span>
                        Preview Icon
                    </span>
                </div>
                <div class="c-cart-icon-preview">
                    <div style="margin-top: 7px;">
                        <i
                            aria-label="Favorite Icon Outline"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.favIconSec"
                            [ngStyle]="{ color: buttonConfig.favIconColor }"
                        ></i>
                        <i
                            aria-label="Favorite Icon Selected"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.favIcon"
                            [ngStyle]="{ color: buttonConfig.favIconColor }"
                        ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- cart icon-->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Cart Icon</div></div>
        <div class="col-sm-3">
            <div class="form-group">
                <div class="c-form-group__label">
                    <label for="cartIcon">Select Icon</label>
                </div>
                <ccl-simple-select formId="cartIcon"
                    [listOfItems]="iconList['cart']"
                    (valueChange)="iconChange($event, 'cartIcon', 'cartIconSec', 'cart')"
                    [value]="buttonConfig.cartIcon"
                    [bindValue]="'class'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="cartColor">Icon Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="cartColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.cartIconColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartIconColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="cartFontSize">Font Size</label></div>
                <ccl-simple-select formId="cartFontSize"
                    [listOfItems]="sharedService.fontSizes"
                    (valueChange)="buttonConfig.cartIconSize = $event.value"
                    [value]="buttonConfig.cartIconSize"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div>
                <div class="c-form-group__label">
                    <span>
                        Preview Icon
                    </span>
                </div>
                <div class="c-cart-icon-preview">
                    <div style="margin-top: 7px;">
                        <i
                            aria-label="Cart Icon"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.cartIcon"
                            [ngStyle]="{ color: buttonConfig.cartIconColor }"
                        ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- exc icon-->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Exclude Icon</div></div>
        <div class="col-sm-3">
            <div class="form-group">
                <div class="c-form-group__label">
                    <label for="excIcon">Select Icon</label>
                </div>
                <ccl-simple-select formId="excIcon"
                    [listOfItems]="iconList['remove']"
                    (valueChange)="iconChange($event, 'excIcon', 'excIconSec', 'remove')"
                    [value]="buttonConfig.excIcon"
                    [bindValue]="'class'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="excColor"> Icon Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.excIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="excColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.excIconColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.excIconColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="excFontSize">Font Size</label></div>
                <ccl-simple-select formId="excFontSize"
                    [listOfItems]="sharedService.fontSizes"
                    (valueChange)="buttonConfig.excIconSize = $event.value"
                    [value]="buttonConfig.excIconSize"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-3">
            <div>
                <div class="c-form-group__label">
                    <span>
                        Preview Icon
                    </span>
                </div>
                <div class="c-cart-icon-preview">
                    <div style="margin-top: 7px;">
                        <i
                            aria-label="Exclude Icon"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.excIconSec"
                            [ngStyle]="{ color: buttonConfig.excIconColor }"
                        ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr />
    <!-- reg icon-->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Registered Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="regLabel">Label</label></div>
                <input id="regLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.regLabel"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="regColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.regColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="regColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.regColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.regColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="regBackground">Background Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.regBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="regBackground"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.regBackground"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.regBackground }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="regFontStyle">Font Style</label></div>
                <ccl-simple-select formId="regFontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="buttonConfig.regFontStyle = $event.value"
                    [value]="buttonConfig.regFontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- wait icon-->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Waitlisted Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="waitLabel">Label</label></div>
                <input id="waitLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.waitLabel"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="waitColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.waitColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="waitColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.waitColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.waitColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="waitBackground">Background Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.waitBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="waitBackground"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.waitBackground"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.waitBackground }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="wlFontStyle">Font Style</label></div>
                <ccl-simple-select formId="wlregFontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="buttonConfig.waitFontStyle = $event.value"
                    [value]="buttonConfig.waitFontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <!-- <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="expansionStyle">Font size</label></div>
                <ccl-simple-select
                    [listOfItems]="sharedService.fontSizes"
                    (valueChange)="buttonConfig.waitFontSize = $event.value"
                    [value]="buttonConfig.waitFontSize"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div> -->
    </div>

    <!-- filling fast -->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Filling Fast Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="fillLabel">Label</label></div>
                <input id="fillLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.fillingFastLabel"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="percentage">Remaining Percentage</label></div>
                <input id="percentage"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.fillingFastPercent"
                    maxlength="3"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="fillColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.fillingFastColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="fillColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.fillingFastColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.fillingFastColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="fillFontStyle">Font Style</label></div>
                <ccl-simple-select formId="fillFontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="buttonConfig.fillingFastFontStyle = $event.value"
                    [value]="buttonConfig.fillingFastFontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <!-- Capacity Full Label -->
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Capacity Full Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="capLabel">Label</label></div>
                <input id="capLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.capacityFullLabel"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="capColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.capacityFullColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="capColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.capacityFullColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.capacityFullColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="capFontStyle">Font Style</label></div>
                <ccl-simple-select formId="capFontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="buttonConfig.capacityFullFontStyle = $event.value"
                    [value]="buttonConfig.capacityFullFontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="c-title--subsection col-sm-6" style="margin-top: 8px;">Add to Cart Button</div>
        <div class="col col-sm-6">
            <ccl-toggle-button
                [title]="buttonConfig.enableAddToCartButton ? 'Enabled' : 'Disabled'"
                [isChecked]="buttonConfig.enableAddToCartButton"
                (isCheckedChange)="toggleAddToCartButton($event)"
                >{{ buttonConfig.enableAddToCartButton ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
        </div>
    </div>

    <!-- add to cart button-->
    <div *ngIf="buttonConfig.enableAddToCartButton" class="row">
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="addLabel">Label</label></div>
                <input id="addLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="buttonConfig.cartButtonLabel"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="addBackground">Background</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartButtonBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="addBackground"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.cartButtonBackground"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartButtonBackground }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="addColor">Font Color </label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartButtonColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
                >
                    <input id="addColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="buttonConfig.cartButtonColor"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartButtonColor }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="addFontStyle">Font style</label></div>
                <ccl-simple-select formId="addFontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="buttonConfig.cartButtonStyle = $event.value"
                    [value]="buttonConfig.cartButtonStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <!-- <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="expansionStyle">Font size</label></div>
                <ccl-simple-select
                    [listOfItems]="sharedService.fontSizes"
                    (valueChange)="buttonConfig.cartButtonSize = $event.value"
                    [value]="buttonConfig.cartButtonSize"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div> -->
    </div>
</div>
